const privilegeValue = (value) => {
  if (typeof value === "string") return value;
  return value?.name || value?.scope || value?.code || value?.authority || value?.privilege?.name || value?.privilege?.scope || "";
};

export const normalizeCarePrivilege = (value) =>
  privilegeValue(value).trim().toUpperCase().replace(/[^A-Z0-9]+/g, "_");

const memberUserId = (membership = {}) =>
  membership?.user?.id || membership?.userId || membership?.memberUserId || membership?.profileId || "";

export const workspacePrivilegeSet = ({ privileges = [], user, workspace } = {}) => {
  const actorId = user?.id || user?.userId || user?.uid || "";
  const membership = (workspace?.users || []).find(
    (item) => String(memberUserId(item)) === String(actorId),
  );
  return new Set([
    ...privileges,
    ...(membership?.privilegeNames || []),
    ...(membership?.privilegeScopes || []),
    ...(membership?.privileges || []),
  ].map(normalizeCarePrivilege).filter(Boolean));
};

export const hasWorkspacePrivilege = (context, privilege) =>
  workspacePrivilegeSet(context).has(normalizeCarePrivilege(privilege));

export const CARE_VIEW_INCIDENTS = "CARE_VIEW_INCIDENTS";
export const CARE_MNG_INCIDENTS = "CARE_MNG_INCIDENTS";
